var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h96v320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }